import React from 'react';
import {
  Text, 
  View, ScrollView, TouchableOpacity,
} from 'react-native';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import {Helmet} from 'react-helmet';

import { enUS } from './en-US.js';
import { zhHK } from './zh-HK.js';
import { host, api11 } from '../../config/api.js';
import { formStyles } from '../../config/styles.js';
import { clearEmptyStrings, hmacSha256, msgCodeDetail} from '../../lib/utils.js';
import { languageStorage } from '../../lib/LanguageStorage.js';
import TextInput from '../../components/TextField/TextField.js';
import Navbar from '../../components/Navbar/Navbar.js';
import Footer from '../../components/Footer/Footer.js';
import validate from 'validate.js';
import ModalOTP from '../../components/ModalOTP/ModalOTP.js';
import Alert from '../../components/Alert/Alert.js';
import YesNoRadio from '../../components/YesNoRadio/YesNoRadio.js';

export default class ForgotPasswordScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: {},
      messages: {},
      isUseSMS:"Y" // "Y" || "N"
    };

    try {
      const searchParams = new URLSearchParams(this.props.location.search);

      const lang = searchParams.get('lang');
      if (lang) {
        switch (lang) {
          case 'en':
            languageStorage.setLanguage('enUS');
            break;
          case 'zh':
            languageStorage.setLanguage('zhHK');
            break;
        }
      }
    }
    catch (e) {
      if (e.name != 'ReferenceError') {
        throw e;
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    const getText = (language) => {
      let text = enUS;
      if (language == 'zhHK') {
        text = zhHK;
      }
      return text;
    };
    languageStorage.getLanguage(
      (language) => this.setState({
        language: language,
        text: getText(language)
      }));
  }

  showError(text) {
    this.setState({
      alert: Alert.alert(this.state.text.alert, text || "Some Error happen" , [
        {
          text: this.state.text.ok,
          onPress: () => {
            this.setState({ alert: null });
          },
        },
      ]),
    });
  }

  showInfo(text, callback) {
    if(!text){
      return;
    }
    this.setState({
      alert: Alert.alert(this.state.text.alert, text , [
        {
          text: this.state.text.ok,
          onPress: () => {
            this.setState({ alert: null });
            callback?.()
          },
        },
      ]),
    });
  }
  
  async _checkUserExist(){
    const data = JSON.stringify({
      username: this.state.mobileNumber,
      timeStamp: Date.now(),
    });

    const hmac = hmacSha256(data);

    try {
      const response = await fetch(host + "/member/password/verify", {
        method: "POST",
        credentials: 'include',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "data=" + encodeURIComponent(data) + "&hmac=" + hmac,
      });

      const responseJson = await response.json();
      return responseJson.msgCode === 0;
    } catch (error) {
      return false;
    }
  }
  async _sendShortMessage(isSendEmail) {
    const data = JSON.stringify({
      mobile: this.state.mobileNumber,
      isSendEmail: isSendEmail ? "Y" : "N",
      isExistingUser: "Y",
      timeStamp: Date.now(),
    });

    const hmac = hmacSha256(data);

    try {
      const response = await fetch(host + api11, {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'data=' + encodeURIComponent(data) + '&hmac=' + hmac,
      });

      const responseJson = await response.json();
      return responseJson
    } catch (error) {
      return error

    }
  }

  async _clickForgotPasswordButton() {
    const state = clearEmptyStrings(this.state);

    let attributes = {
      mobileNumber: this.state.mobileNumber,
    };

    let constraints = {
      mobileNumber: {
        presence: { message: this.state.text.thisFieldCannotBeBlank },
        numericality: { message: this.state.text.invalidMobileNumber },
        length: { is: 8, message: this.state.text.invalidMobileNumber },
      },
    };

    const messages = validate(attributes, constraints, { fullMessages: false });

    if (messages) {
      this.setState({ messages });
      return;
    }

    if (this.state.shortMessageSending) {
      return;
    }

    this.setState({
      messages: {},
      shortMessageSending: true,
    });

    // check user exist
    // const isUserExist = await this._checkUserExist();
    // if(!isUserExist){
    //   this.setState({ shortMessageSending: false });
    //   this.showError(this.state.text.noSuchUser);
    //   return
    // }

    const responseJson = await this._sendShortMessage(this.state.isUseSMS === "N")
    if (responseJson.msgCode === 0 || responseJson.msgCode === 89) {
        this.showInfo(
          msgCodeDetail(89)[
            this.state.language === 'enUS' ? 'desc_en' : 'desc_zh'
          ]
          ,true ? ()=>{
            this.setState({
              targetPhoneNumber: this.state.mobileNumber,
              shortMessageSent: true,
            })
          } : undefined
        );
    } else {
      if(!!responseJson.msgCode){
        this.showError(
          msgCodeDetail(responseJson.msgCode)[
            this.state.language === 'enUS' ? 'desc_en' : 'desc_zh'
          ]
        );
      }else{
        this.showError(this.state.text.sendSMSerror);
      }
    }
    this.setState({ shortMessageSending: false });
  }


  _checkOTP(otpCode) {
    if (this.state.registering) {
      return;
    }
    this.setState({registering : true});
    const data = JSON.stringify({
      username: this.state.mobileNumber,
      verify_code: otpCode,
      timeStamp: Date.now(),
    });
    const hmac = hmacSha256(data);
    fetch(host + "/member/verify/check", {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: 'data=' + encodeURIComponent(data) + '&hmac=' + hmac + '&keep=1',
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.msgCode == 0) {
        this.props.history.push({
          pathname: "/set-password",
          state: { username: this.state.mobileNumber , otpCode }
        }
);
        this.setState({registering : false});
      }
      else {
        this.showError(msgCodeDetail(responseJson.msgCode)
          [this.state.language == 'enUS' ? 'desc_en' : 'desc_zh']);
        this.setState({registering : false});
      }
    })
    .catch((error) => {
      this.showError(this.state.text.forgotPasswordError);
      this.setState({registering : false});
    });
  }


  render() {
    return (
      <div className='App'>
        <Helmet>
          <title>Forgot Password or Haven't Setup Password | Bravo Generali</title>
        </Helmet>

        <Navbar
          title={this.state.text.forgotOrNoPassword}
          backButton
          history={this.props.history}
        />

        <Grid container spacing={20} style={{backgroundColor: '#f2f2f2'}}>
        <Hidden xsDown>
          <Grid item xs style={{marginBottom:13,marginLeft:'5%',marginRight:'5%'}}>
            {/* <View style={[styles.greeting,{fontWeight:'bold',}]}>
              <Text style={[styles.greetingText,{marginTop:'10%',fontSize: 35,}]}>{this.state.text.forgotOrNoPassword}</Text>
            </View> */}
          </Grid>
        </Hidden>

          <Grid item xs style={{marginTop:30,marginBottom:50,backgroundColor: 'white',}}>
          <ScrollView style={{...formStyles.form, ...styles.fieldsetldset}}>

            {this.state.alert}
            <View style={formStyles.fieldset}>
              <Text style={formStyles.h3}>{this.state.text.forgotOrNoPassword}</Text>
            </View>

            <View style={formStyles.fieldset}>
              <Text style={formStyles.h4}>{this.state.text.mobileNumber}</Text>
                <TextInput
                  style={formStyles.input}
                  onChangeText={(text) => this.setState({mobileNumber: text})}
                  value={this.state.mobileNumber}
                  keyboardType='text'
                />
                <Text style={formStyles.message}>{this.state.messages.mobileNumber}</Text>
            </View>
            <View style={formStyles.fieldset}>
              <YesNoRadio
                choice={this.state.isUseSMS}
                question={this.state.text.otpMethod}
                questionStyle={{marginTop:"10px"}}
                onChange={(v)=>this.setState({isUseSMS:v})}
                noLabel={this.state.text.email}
                yesLabel="SMS"
              />
            </View>
            <View>
              {
                this.state.shortMessageSending ?
                  <View style={formStyles.submitButtonDisabled}>
                    <Text style={formStyles.submitButtonText}>
                      {this.state.text.pleaseWait}
                    </Text>
                  </View> :
                  <TouchableOpacity
                    style={formStyles.submitButton}
                    onPress={() => this._clickForgotPasswordButton()}
                  >
                    <Text style={formStyles.submitButtonText}>
                      {this.state.text.sendOTP}
                    </Text>
                  </TouchableOpacity>
              }
            </View>
          </ScrollView>
         </Grid>
           <Hidden xsDown>
            <div style={{marginRight: '5%'}} />
           </Hidden>
      </Grid>

      <ModalOTP 
        open={this.state.shortMessageSent}
        onClose={()=>this.setState({shortMessageSent:false})}
        onSubmit={(opt)=>this._checkOTP(opt)}
        onResend={(bool)=>this._sendShortMessage(bool)}
        />
      <Footer/>
   </div>
    );
  }
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'stretch',
  },
  fieldsetldset: {
    margin: 'auto',
    minWidth: 300,
    maxWidth: 600,
    minHeight: 580,
    paddingLeft: 20,
   paddingRight: 20,
  },
};
